import type { EffectCallback } from 'react';
import { useEffect } from 'react';

/**
 * @see https://github.com/banhala/bori/blob/main/packages/libraries/ably-webview-react/src/hooks/useMount/index.ts
 */
export const useMount = (cb: EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(cb, []);
};
